import { FaLinkedinIn, FaYoutube, FaCheckCircle } from 'react-icons/fa';
import { MdEmail, MdLocationOn, MdPhone } from 'react-icons/md';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import NewsletterForm from '../Newsletterform';
import { PRACTICES, hubServiceOrder, practicePath, servicePath } from '../../content/services';
import { NAP, PRIMARY_NAV } from '../../content/site';

import footerBgLogo from '../../assets/BizSolutions png.png';

// The full header nav, Services included. There is no longer a "Services"
// column for it to duplicate -- each practice is its own column now.
const QUICK_LINKS = PRIMARY_NAV;

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  return (
    <footer
      className="footer"
      style={{
        position: 'relative',
        overflow: 'hidden',
        background: '#090b2f'
      }}
    >
      <img
        src={footerBgLogo}
        alt=""
        aria-hidden="true"
        style={{
          position: 'absolute',
          right: '-80px',
          top: '50%',
          transform: 'translateY(-50%)',
          width: '820px',
          maxWidth: 'none',
          opacity: 0.65,
          zIndex: 0,
          pointerEvents: 'none'
        }}
      />

      <div
        style={{
          position: 'absolute',
          inset: 0,
          background: `
            linear-gradient(
              90deg,
              rgba(9, 11, 47, 1) 0%,
              rgba(9, 11, 47, 0.98) 42%,
              rgba(9, 11, 47, 0.88) 65%,
              rgba(9, 11, 47, 0.72) 82%,
              rgba(9, 11, 47, 0.55) 100%
            )
          `,
          zIndex: 1,
          pointerEvents: 'none'
        }}
      />

      {showSuccessPopup && (
        <div className="successPopup">
          <div className="popupContent">
            <FaCheckCircle className="successIcon" />
            <p>Thank you for subscribing to our newsletter!</p>
            <button className="closeBtn" onClick={() => setShowSuccessPopup(false)}>
              Close
            </button>
          </div>
        </div>
      )}

      <div
        className="container"
        style={{
          position: 'relative',
          zIndex: 2
        }}
      >
        <div className="footer-grid">
          <div className="footer-col">
            <h3>BizSolutions</h3>

            <div className="contact-info">
              <p>
                <MdEmail /> <a href={`mailto:${NAP.email}`}>{NAP.email}</a>
              </p>
              <p>
                <MdLocationOn /> {NAP.address.full}
              </p>
              <p>
                <MdPhone /> <a href={NAP.phone.href}>{NAP.phone.display}</a>
              </p>
            </div>

            <div className="social-links">
              <a href="https://www.linkedin.com/company/business-solutions-and-technologies-llc" target="_blank" rel="noopener noreferrer">
                <FaLinkedinIn className="social-icon" />
              </a>
              <a href="https://www.youtube.com/channel/UCkxx3yHym7_c_3e7m05RHHA" target="_blank" rel="noopener noreferrer">
                <FaYoutube className="social-icon" />
              </a>
            </div>

            <div className="youtube-subscribe">
              <p>Subscribe to our YouTube channel to see future demonstrations of our work</p>
            </div>
          </div>

          <div className="footer-col">
            <h3>Quick Links</h3>
            <ul>
              {QUICK_LINKS.map((item) => (
                <li key={item.path}>
                  <Link to={item.path} onClick={scrollToTop}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* One column per practice, each headed by a link to its hub and
              listing that practice's full service list. This is the header's
              Services dropdown, rendered as footer columns -- both are built
              from PRACTICES, so adding a service reaches all three surfaces
              without a second edit. Services appear in the same order the hub
              pages use them. */}
          {PRACTICES.map((practice) => (
            <div className="footer-col" key={practice.slug}>
              <h3>
                <Link to={practicePath(practice)} onClick={scrollToTop}>
                  {practice.name}
                </Link>
              </h3>
              <ul>
                {hubServiceOrder(practice).map((service) => (
                  <li key={service.slug}>
                    <Link to={servicePath(service)} onClick={scrollToTop}>
                      {service.navLabel}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="footer-col">
            <h3>Newsletter</h3>
            <p>Stay updated with our latest news and offers</p>
            <NewsletterForm />
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} BizSolutions.Tech. All rights reserved.</p>
          <div className="footer-links">
            <Link to="/privacy-policy" onClick={scrollToTop}>Privacy Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
